var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.991 42.7046L123 42.1762L122.327 41.2943C114.594 29.9137 102.891 22.1255 89.7143 19.5905V0H69.7098V19.4119C57.3756 22.0105 46.2851 28.965 38.3186 39.0964C30.3522 49.2278 26 61.9125 26 74.9999C26 88.0874 30.3522 100.772 38.3186 110.904C46.2851 121.035 57.3756 127.99 69.7098 130.588V150H89.7143V130.413C93.7892 129.595 97.7448 128.23 101.482 126.354L102.491 125.825L101.818 124.944C98.0778 119.41 95.3957 113.18 93.9183 106.592L93.582 105.532L92.573 106.06C88.6259 107.99 84.3255 109.013 79.9643 109.059C62.146 109.059 48.5283 94.4137 48.5283 74.827C48.3635 70.4173 49.0609 66.0187 50.5783 61.8975C52.0957 57.7762 54.4015 54.018 57.3561 50.8504C60.3107 47.6828 63.8527 45.1718 67.7676 43.4691C71.6826 41.7664 75.8891 40.9075 80.1324 40.9446C84.9549 40.8804 89.7182 42.0547 93.9998 44.3634C98.2813 46.6721 101.949 50.044 104.677 54.1798L105.35 55.0616L106.023 54.1798C110.528 49.2512 115.965 45.3444 121.991 42.7046Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.696d1813e6fd53a3d9df512b3648286c.svg";
export { ForwardRef as ReactComponent };